import { ApolloClient, from, HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getRuntimeConfig } from "authentication/runtimeConfig";
import { getTokenWithRetry } from "utils/enhancedAuth";
import cache from "./cache";
import errorLink from "./errorLink";
import resolvers from "./resolvers";

const authLink = setContext(
  (_, { headers }) =>
    new Promise((resolve) => {
      getTokenWithRetry(1)
        .then((token) => {
          resolve({
            headers: {
              ...headers,
              authorization: token ? `Bearer ${token}` : "",
            },
          });
        })
        .catch((e) => {
          console.warn("Apollo Client: Enhanced token retrieval failed, proceeding without token", e);
          resolve({
            headers: {
              ...headers,
              authorization: "",
            },
          });
        });
    })
);

const wipAuth = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${import.meta.env.VITE_CUSTOM_BEARER}`,
    },
  };
});

// Use runtime configuration for GraphQL URI
const getGraphQLUri = () => {
  try {
    const config = getRuntimeConfig();
    return config.api.graphqlUri;
  } catch {
    return import.meta.env.VITE_GRAPHQL_URI ?? "";
  }
};

const httpLink = new HttpLink({
  uri: getGraphQLUri(),
});

const link = import.meta.env.VITE_CUSTOM_BEARER ? from([wipAuth, httpLink]) : from([authLink, httpLink]);

const client = new ApolloClient({
  cache: cache,

  link: from([errorLink, link]),
  resolvers,
  connectToDevTools: true,
});

export default client;
